<template>
  <div class="radioInputWrapper">
    <ValidationProvider
      :rules="validation"
      v-slot="{ errors }"
      :name="name"
    >
      <div class="inputWrapper" :style="styles">
        <div v-for="option in options" :key="option.name">
          <input
            v-model="localSelected"
            type="radio"
            :name="fieldId"
            :id="option.name"
            :value="option.value"
            checked
            :disabled="option.disabled"
          />
          <label :for="option.name">{{ option.text }}</label>
        </div>
      </div>
      <div
        class="validation-error"
        style="margin-left: 5px"
        v-if="errors.length"
      >
        <img class="error_min" src="../../assets/icons/form/error.svg" alt />
        {{ errors[0] }}
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: "radio-input",
  data() {
    return {
      localSelected: this.selectedValue || ""
    };
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    field: {
      required: false,
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true
    },
    fieldId: {
      type: String,
      required: true
    },
    selectedValue: {
      type: String,
      required: false,
      default: ""
    },
    validation: {
      type: String,
      required: false
    },
    direction: {
      type: String,
      required: false,
      default: "row"
    },
    color: {
      type: String,
      default: "#000"
    },
    styles:{
      type: Object,
      default: ()=>{}
    }
  },
  watch: {
    localSelected(value) {
      this.$emit("component-updated", {
        selectedValue: value
      });
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
$medium: 800px;
.validation-error {
  position: absolute;
}

.radioInputWrapper {
   font-family: "Plus Jakarta Sans";
  font-weight: 500;
  font-size: 18px;
  @media only screen and (max-width: $medium) {
    margin-left: 30px;
    margin-right: 20px;
  }
  padding: 5px;

  .inputWrapper {
    display: flex;

    .radio-input {
      margin: 3px;
    }
  }
}

input {
  display: none;

  &:checked {
    + label:before {
      display: none;
    }

    + label:after {
      width: 20px;
      left: 0;
      height: 20px;
      content: "";
      background-image: url("../../assets/icons/form/round-checkbox-checked.svg") !important;
      background-repeat: no-repeat;
      background-size: 20px;
      position: absolute;
    }
  }
}

label {
  padding-left: 25px;
  padding-right: 15px;
  position: relative;

  &:before {
    left: 0;
    width: 20px;
    height: 20px;
    content: "";
    background-image: url("../../assets/icons/form/round-checkbox.svg") !important;
    background-repeat: no-repeat;
    background-size: 20px;
    position: absolute;
  }
}
</style>
